import moment from 'moment-jalaali';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getTruthy } from 'utils/happyFunctions';
import {
  bytesToSize,
  isANumber,
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from 'utils/number';
import { IDataContext, withDataContext } from 'store/context/DataContext';
import { RootState } from 'store/store';
// import ClassicEditor from '@rastech-inc/ckeditor';
import Icon from 'components/Icon';
import { stringToColour } from 'utils/style/colors';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../../../CKEditorField/CKEditorField';
import messages from './Messages';
import { FileAnswer, FileInfo, MyBadge } from './styles';
import { ITagView } from 'store/providers/providerTypes';
import { NumberOrNull } from 'store/entity/types';
import {
  IAnswersView,
  IChoiceView,
  IGridAnswerView,
  IGridQuestionView,
  IMultipleAnswerAnswerView,
  IMultipleAnswerField,
  IMultipleAnswerQuestionView,
  IMultipleAnswerSubAnswer,
  IMultipleChoiceAnswerView,
  IQuestionsView,
  ISubAnswer,
  ISurveyItemWithData,
  ISurveyView,
  QuestionType,
} from 'store/survey/surveyTypes';
import {
  SubAnswer,
  SubAnswerWrapper,
} from '../../../../SurveyResponses/styles';
import { iconSelector } from 'utils/fileUtils';
import Thumbnail from '../../../../Thumbnail';
import { TaskAttachmentsModal } from '../../../../../containers/Tasks/TasksManagement/TaskAttachments/Modal/TaskAttachmentsModal';
import { smartDateString } from '../../../../../utils/date';
import DescriptionInput from '../../../../SurveyResponses/DescriptionInput';
import i18n from 'i18next';

interface IComponentProps {
  tags: ITagView;
  answer: IAnswersView;
  question: IQuestionsView;
  dataContext: IDataContext;
  gridPartValue?: string;
  selectedChoices?: Array<string | number>;
  isExam?: boolean;
  showCorrectAnswers?: boolean;
  survey?: ISurveyView;
  providerId: number | undefined;
  surveyItem?: ISurveyItemWithData;
}

function showValue(value: string, type: string) {
  if (type === 'date')
    return convertDigitToProperFormat(
      moment(Number(value)).format('jD jMMMM jYYYY')
    );
  return value;
}

export function convertTimeToString(time: number) {
  const hour = Math.floor(time);
  const minutes = Math.round((time - hour) * 60);
  return (
    <>{`${convertDigitToProperFormat(hour.toString().padStart(2, '0'))}:${convertDigitToProperFormat(minutes.toString().padStart(2, '0'))}`}</>
  );
}

const AnswerView: React.FC<IComponentProps> = ({
  tags,
  answer,
  question,
  gridPartValue,
  selectedChoices,
  isExam,
  showCorrectAnswers,
  survey,
  surveyItem,
}) => {
  const [isFileModalActive, setFileModalActive] = useState(false);
  const desctiption = (
    <>
      {answer.description && (
        // <span>
        //   ({messages.description}: {answer.description})
        // </span>
        <DescriptionInput
          question={question}
          survey={survey}
          open={true}
          id={question.id + 'desc'}
          text={answer && answer.description}
          onChangeInput={() => {
            /*do nothing*/
          }}
          disabled={true}
        />
      )}
    </>
  );
  if (answer.type === QuestionType.Text) {
    // @ts-expect-error it's ok
    const inputType: ITextQuestionView['inputType'] = question.inputType;

    return (
      <p style={{ whiteSpace: 'pre-wrap' }}>
        {inputType !== 'rich' && <Icon type="anchor" className="right" />}
        {inputType === 'rich' ? (
          <div style={{ flexGrow: 1 }}>
            <CKEditorField
              // editor={ClassicEditor}
              data={answer.value.replace(/\n/g, '<br>')}
              disabled={true}
              dir="rtl"
              config={CKEditorReadOnlyConfig}
            />
          </div>
        ) : inputType === 'date' ? (
          <span>
            {Number(answer.value) > 0 &&
              convertDigitToProperFormat(
                moment(Number(answer.value)).format('jD jMMMM jYYYY')
              )}
          </span>
        ) : inputType === 'dateAndTime' ? (
          <span>
            {Number(answer.value) > 0 &&
              smartDateString(+answer.value, true, true, true)}
          </span>
        ) : inputType === 'duration' ? (
          <span> {convertTimeToString(+answer.value)}</span>
        ) : (
          answer.value
        )}
        {desctiption}
      </p>
    );
  } else if (answer.type === QuestionType.MultipleChoice) {
    const getChoiceScore = (score: NumberOrNull, maxScore: number) => {
      return score !== null && score !== undefined
        ? messages.responseScore(
            convertNumbersToProperFormat(getTruthy(score, 0) as number),
            maxScore
          )
        : '';
    };
    if (
      // @ts-expect-error it's ok
      !question.useTags /*&&
      ((typeof answer.get('value') === 'string' &&
        answer.get('value') !== '') ||
        (answer.get('values') && answer.get('values').size > 0))*/
    ) {
      return (
        <React.Fragment>
          <div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {((): any => {
                let maxScoreText: string | null = null;
                // @ts-expect-error it's ok
                const maxScore = question.choiceList.reduce(
                  (current: number | null, item: IChoiceView) => {
                    const score = item.score ?? 0;
                    if (isANumber(score)) {
                      if (current === null) {
                        maxScoreText = item.text;
                        return score;
                      } else {
                        if (score > current) {
                          current = score;
                          maxScoreText = item.text;
                        }
                      }
                    }
                    return current;
                  },
                  null
                );
                return (
                  (answer as IMultipleChoiceAnswerView).values.length
                    ? // @ts-expect-error it's ok
                      Object.values(answer.values)
                    : answer.value
                      ? [answer.value]
                      : []
                ).map((value) => {
                  const choice = (
                    question as IGridQuestionView
                  ).choiceList.find(
                    (item: IChoiceView) => item.value === value
                  );
                  return (
                    <div
                      style={{
                        display: 'flex',
                        width: maxScore ? '100%' : '',
                        margin: '2px 0px',
                        justifyContent: 'space-between',
                      }}
                      key={value as number}
                    >
                      <MyBadge
                        color={stringToColour(
                          question?.title || '',
                          1,
                          false,
                          choice?.text || '',
                          !isExam || showCorrectAnswers
                            ? choice?.score
                            : undefined,
                          !isExam || showCorrectAnswers ? maxScore : undefined
                        )}
                      >
                        {choice?.text}
                      </MyBadge>
                      {!isExam ||
                        (showCorrectAnswers && (
                          <span className="left">
                            {choice && getChoiceScore(choice?.score, maxScore)}
                          </span>
                        ))}
                      {!choice?.score &&
                        isExam &&
                        maxScoreText &&
                        showCorrectAnswers && (
                          <p>
                            {messages.currectAnswer}:
                            <MyBadge
                              color={stringToColour(
                                question?.title || '',
                                1,
                                false,
                                '',
                                1,
                                1
                              )}
                            >
                              {maxScoreText}
                            </MyBadge>
                          </p>
                        )}
                    </div>
                  );
                });
              })()}
            </div>
            {desctiption}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div style={{ display: 'flex' }}>
            {/*// @ts-expect-error it's ok*/}
            {answer.selected.map((tagId: number) => {
              return (
                <>
                  <MyBadge
                    key={tagId}
                    color={stringToColour(
                      question.title,
                      1,
                      false,
                      tags[tagId].text
                    )}
                  >
                    {tags[tagId].text}
                  </MyBadge>
                </>
              );
            })}{' '}
          </div>
          {desctiption}
        </React.Fragment>
      );
    }
  } else if (answer.type === QuestionType.Grid) {
    return (
      <div>
        {((): any => {
          const maxScore = (question as IGridQuestionView).choiceList.reduce(
            (current: number | null, item: IChoiceView) => {
              const score = item.score ?? 0;
              if (isANumber(score)) {
                if (current === null) return score;
                else return Math.max(score, current);
              }
              return current;
            },
            null
          );
          return (answer as IGridAnswerView).subAnswers
            .filter((subAnswer: ISubAnswer) => {
              if (selectedChoices && selectedChoices.length > 0) {
                return selectedChoices.find(
                  (value) => value === subAnswer.value
                );
              }
              return true;
            })
            .map((subAnswer: ISubAnswer) => {
              const filteredQuestionParts: IChoiceView[] = gridPartValue
                ? // @ts-expect-error it's ok
                  question.parts.filter(
                    (part: IChoiceView) => part.value === gridPartValue
                  )!
                : (question as IGridQuestionView).parts!;
              const subQuestion = filteredQuestionParts.find(
                (part) => part.value === subAnswer.subQuestionValue
              );
              // @ts-expect-error it's ok
              const subValue: any | undefined = question.choiceList.find(
                (choice: IChoiceView) => choice.value === subAnswer.value
              );
              const showQuestion = !gridPartValue || subQuestion;
              return (
                showQuestion && (
                  <div
                    key={subAnswer.subQuestionValue}
                    style={{ margin: '0.4rem' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                      }}
                    >
                      <span
                        style={{ display: 'flex', alignItems: 'flex-start' }}
                      >
                        <Icon type="menu" className="right" />
                        {subQuestion
                          ? subQuestion.text
                          : messages.deletedQuestion}{' '}
                        :{'  '}
                      </span>
                      <MyBadge
                        style={{ margin: '0em 0.4rem', flexShrink: 0 }}
                        color={stringToColour(
                          question.title,
                          1,
                          false,
                          subValue?.text,
                          subValue?.score,
                          maxScore
                        )}
                      >
                        {subValue?.text || messages.deletedValue}
                        {isANumber(maxScore)
                          ? subValue?.score !== null &&
                            subValue?.score !== undefined
                            ? messages.gridResponseScore(
                                getTruthy(
                                  subValue?.score,
                                  messages.withoutScore
                                ),
                                subValue?.text,
                                Number(maxScore)
                              )
                            : ''
                          : ''}
                      </MyBadge>
                    </div>
                    {subAnswer?.description && (
                      <DescriptionInput
                        question={question}
                        survey={survey}
                        open={true}
                        id={question.id + 'desc'}
                        text={subAnswer && subAnswer.description}
                        onChangeInput={() => {
                          /*do nothing*/
                        }}
                        disabled={true}
                      />
                    )}
                  </div>
                )
              );
            });
        })()}
      </div>
    );
  } else if (answer.type === QuestionType.MultipleAnswer) {
    const questionObj = question as IMultipleAnswerQuestionView;
    const answerObj = answer as IMultipleAnswerAnswerView;
    return (
      <div style={{ overflow: 'hidden' }}>
        {answerObj.subAnswerList.map(
          (subAnswer: IMultipleAnswerSubAnswer, answerIndex: number) => {
            return (
              <SubAnswerWrapper
                className="col m12 l6 s12"
                key={questionObj.id + '_' + answerIndex}
              >
                <SubAnswer>
                  {questionObj.questionFields.map(
                    (questionField: IMultipleAnswerField) => {
                      if (questionField.hidden) return <></>;
                      const item =
                        subAnswer.values &&
                        subAnswer.values.find(
                          (item) => item.key === questionField.key!
                        );
                      const value = (item && item.value) || undefined;
                      return (
                        <p
                          key={
                            questionObj.id +
                            '_' +
                            answerIndex +
                            '_' +
                            questionField.key
                          }
                          style={{ whiteSpace: 'pre-line' }}
                        >
                          <b>{questionField.title}</b>:{' '}
                          {value
                            ? showValue(
                                value,
                                questionField.inputType || 'text'
                              )
                            : ''}
                        </p>
                      );
                    }
                  )}
                </SubAnswer>
              </SubAnswerWrapper>
            );
          }
        )}
      </div>
    );
  } else if (
    answer.type === QuestionType.Indicator &&
    question.type === 'indicator'
  ) {
    if ((question.denominator || '').length > 0) {
      return (
        <React.Fragment>
          <span>
            <p>
              <Icon type="arrow-up" className="right" />
              {question.numerator}:{' '}
              {question.numeratorUnit === messages.hour
                ? // @ts-expect-error it's ok
                  convertTimeToString(+answer.numerator)
                : // @ts-expect-error it's ok
                  convertNumbersToProperFormat(answer.numerator)}
            </p>
            <p>
              <Icon type="arrow-down" className="right" />
              {question.denominator}:{' '}
              {question.denominatorUnit === messages.hour
                ? // @ts-expect-error it's ok
                  convertTimeToString(+answer.denominator)
                : // @ts-expect-error it's ok
                  convertNumbersToProperFormat(answer.denominator)}
            </p>
            <p>
              <Icon type="upload" className="right" />
              {messages.indicatorResult(
                convertNumbersToProperFormat(
                  answer.score! * (question.unit === 'percent' ? 100 : 1),
                  4
                ),
                question.unit === 'percent' || question.unit === 'fraction'
                  ? i18n.t(question.unit, { ns: 'survey' })
                  : question.denominatorUnit
                    ? question.numeratorUnit + '/' + question.denominatorUnit
                    : question.numeratorUnit!
              )}
            </p>
          </span>
          {desctiption}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <p>
            <Icon type="arrow-up" className="right" />
            {question.numerator}:{' '}
            {question.numeratorUnit === messages.hour
              ? // @ts-expect-error it's ok
                convertTimeToString(+answer.numerator)
              : // @ts-expect-error it's ok
                convertNumbersToProperFormat(answer.numerator)}
          </p>
          {desctiption}
        </React.Fragment>
      );
    }
  } else if (answer.type === QuestionType.File) {
    // @ts-expect-error it's ok
    const file = answer.file;
    return (
      <>
        {file?.id && (
          <FileAnswer>
            <Thumbnail
              src={file.thumbnailUrl || iconSelector(file.properties.format)}
              onClick={() => {
                setFileModalActive(true);
              }}
            />
            <FileInfo>
              <p>{messages.fileName(file.properties.displayName)}</p>
              <p>{messages.fileSize(bytesToSize(file.fileSize))}</p>
              <p>{messages.fileType(file.properties.format)}</p>
            </FileInfo>
            <TaskAttachmentsModal
              isActive={isFileModalActive}
              attachments={[
                {
                  document: file,
                  id: -1,
                  taskId: -1,
                  deleted: false,
                  senderId: 0,
                },
              ]}
              selectedIndex={0}
              users={undefined}
              onIndexChanged={undefined}
              onClose={(): void => {
                setFileModalActive(false);
              }}
              editableToken={
                surveyItem?.data?.editToken || surveyItem?.data?.editable
              }
            />
          </FileAnswer>
        )}
        {desctiption}
      </>
    );
  }
  return <p>unknown answer type</p>;
};

const mapStateToProps = (state: RootState, props: IComponentProps) => {
  const providerId =
    Number(props.dataContext.providerId) || props.providerId || 0;
  const tags = state.providers.tags[providerId!]?.data;

  return { tags };
};

// @ts-expect-error it's ok
export default withDataContext(connect(mapStateToProps)(AnswerView));
